module.exports = __webpack_public_path__ + "static/media/16.6960a539.JPG";